import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { ThirdCompanyResponseModel } from '../../../models/configuration/company/third-company.model';
import { ThirdCompanyResponseEntity } from '../../../../data/repositories/configuration/entities/company/third-company.entity';

export class GetThirdCompanyAllUseCase implements UseCase<{IdEmpresa:string}, ThirdCompanyResponseModel>{
    constructor(private configRepository: ConfigurationRepository) { }
    execute(
      params: {IdEmpresa:string}
    ): Observable<ThirdCompanyResponseEntity> {
      return this.configRepository.getThirdCompanyAll(params);
    }
}